import {
  Skeleton,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react'

export const MockLoadingTable = ({ headers }) => {
  return (
    <TableContainer>
      <Table size={['sm', 'md']}>
        <Thead>
          <Tr>
            {headers?.map((header, index) => (
              <Th key={index}>{header}</Th>
            ))}
          </Tr>
        </Thead>

        <Tbody>
          {[1, 2, 3].map((_, index) => {
            return (
              <Tr key={index}>
                {headers.map((_, index) => (
                  <Td key={index}>
                    <Skeleton height="20px" />
                  </Td>
                ))}
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </TableContainer>
  )
}
